import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api } from "@/lib/api";

export default function AdminAudit() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Audit</div>
          <h1 className="font-display text-3xl mt-2">Audit Logs</h1>
        </div>
        <Card className="p-0 overflow-hidden">
          <Table>
            <TableHeader><TableRow><TableHead>Time</TableHead><TableHead>Actor</TableHead><TableHead>Action</TableHead><TableHead>Target</TableHead><TableHead>Meta</TableHead></TableRow></TableHeader>
            <TableBody>
              {rows.map((r, i) => (
                <TableRow key={i}>
                  <TableCell className="text-xs">{new Date(r.created_at).toLocaleString()}</TableCell>
                  <TableCell className="font-mono text-xs">{String(r.actor_id).slice(0, 8)}</TableCell>
                  <TableCell>{r.action}</TableCell>
                  <TableCell className="font-mono text-xs">{String(r.target || "").slice(0, 12)}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{JSON.stringify(r.meta || {})}</TableCell>
                </TableRow>
              ))}
              {rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">No audit entries.</TableCell></TableRow>}
            </TableBody>
          </Table>
        </Card>
      </div>
    </AdminLayout>
  );
}
